<script setup lang="ts">
import Typography from '@/components/ui/typography/Typography.vue'
import Separator from '@/components/ui/separator/Separator.vue'
import type { Drill } from '@acepoker/contract'
import { computed } from 'vue'

const { config, maxPlayers, startingStack } = defineProps<{
  config: Drill['gaming_configuration']
  maxPlayers: number
  startingStack: number
}>()

const stackInBB = computed(() => startingStack / config.blinds[1])
const stackInStraddles = computed(() =>
  config.blinds[2] ? startingStack / config.blinds[2] : null
)
</script>

<template>
  <Typography :class="`w-fit flex text-[13px]`" color="secondary">
    <template v-if="config.blinds[2]"> {{ $t('NLHDrillsPage.label.Straddle') }} + </template>
    {{ $t('NLHDrillsPage.label.Ante') }}
    <Separator orientation="vertical" class="mx-[6px] opacity-30" />
    {{ maxPlayers }}
    {{ $t('label.max') }}
    <Separator orientation="vertical" class="mx-[6px] opacity-30" />
    {{ stackInBB }} {{ $t('NLHDrillsPage.label.BB') }}
    <template v-if="config.blinds[2]">
      ({{ stackInStraddles }} {{ $t('NLHDrillsPage.label.Str') }})
    </template>
  </Typography>
</template>
